import { getCollection, COLLECTIONS } from 'state/snapi/slice';

// Load Memberships
export const loadMemberRegistrationSignups = params => dispatch =>
  dispatch(getCollection(COLLECTIONS.MEMBER_REGISTRATION_SIGNUPS, 'member_registration_signups/search', params));
